/// <reference path="../HTML/App/Search.ts" />
/// <reference path="./App.ts" />
namespace HA.Core.Entity {
    import SearchTag = HA.Core.HTML.App.Search;
    export class Search extends App {

        protected createTag(data: any) {
            this.addToData("tag", new SearchTag(data));
        }

    }
}
